var exports = {
  "i": "xcc377c0b--2d7392--wrapper",
};

module.exports = exports;
